import React from 'react'
import PromoCreate from '../promo_components/promo_create'
import { Card, CardContent, CardHeader } from '@mui/material'

export default function Main() {
  return (
    <div className='content-wrapper bg-white p-5' style={{ marginLeft: 0 }}>
      <div>
        <h2>Create Promotion</h2>
        <PromoCreate />
      </div>
    </div>
  )
}
